import { View } from "react-native-ui-lib";
import { LinklyPairFormProvider } from "./LinklyPairFormProvider";
import { ControlledTextField, Stack } from "@towersystems/roam-common-native";
import { LinklyPairFormValues } from "./types";
import { useFormContext } from "react-hook-form";

export interface LinklyPairFormProps {}

export const LinklyPairForm = ({}: LinklyPairFormProps) => {
  const { control } = useFormContext<LinklyPairFormValues>();
  return (
    <Stack vertical>
      <ControlledTextField
        control={control}
        label="Name"
        placeholder="Name"
        name="name"
        filled={false}
      />
      <ControlledTextField
        control={control}
        label="Username"
        placeholder="Username"
        name="username"
        filled={false}
      />
      <ControlledTextField
        control={control}
        label="Password"
        placeholder="Password"
        name="password"
        filled={false}
      />
      <ControlledTextField
        control={control}
        label="Pair code"
        placeholder="Pair code"
        name="pairCode"
        filled={false}
      />
    </Stack>
  );
};

LinklyPairForm.LinklyPairFormProvider = LinklyPairFormProvider;
